<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/projects' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header>
        <h1>{{ $t('edit') }} {{ $t('project') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
            <div class="row">
                <span class="label">{{ $t('project') }}</span>
                <div class="inputs">
                    <heim-input :label="$t('customer') + ' *'" name="name" :placeholder="$t('customer')" v-model="project.name" v-validate="'required'"></heim-input>
                     <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
                    <heim-select
                        :label="$t('techno')"
                        :data="types"
                        label-key="type"
                        value-key="id"
                        v-model="project.type_id"
                        required="required"
                    ></heim-select>
                    <heim-textarea :label="$t('description') + ' *'" name="description" :placeholder="$t('description')" v-model="project.description" v-validate="'required'"></heim-textarea>
                    <span v-show="errors.has('description')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('description') }}</span>
                    <heim-input :label="$t('title') + ' *'" name="title" :placeholder="$t('title')" v-model="project.title" v-validate="'required|max:25'"></heim-input>
                    <span v-show="errors.has('title')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('title') }}</span>
                    <div class="heim-input">
                    <datepicker 
                        type="date"
                        name="date"
                        input-class="paper-input"
                        wrapper-class="date-input"
                        v-model="project.date"
                        :placeholder="$t('selectDate')"
                        ></datepicker>
                    </div>
                    <heim-select
                        :label="$t('manager')"
                        :data="users"
                        label-key="name"
                        value-key="id"
                        v-model="project.user_id"
                    ></heim-select>
                    <heim-input :label="$t('projectMantis')" name="mantis_id" :placeholder="$t('projectMantis')" v-model="project.mantis_id" type="number"></heim-input>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('status') }}</span>
                <div class="inputs">
                    <heim-select2
                        :label="$t('status')"
                        :data="status"
                        label-key="name"
                        value-key="id"
                        v-model="project.status_id"
                    ></heim-select2>
                    <heim-input
                        :label="$t('quoteNumber')"
                        name="quote"
                        v-model="project.quote"
                    ></heim-input>
                    <heim-input
                      :label="$t('amount')"
                      name="amount"
                      type="number"
                      step="0.01"
                      v-model="project.amount"
                      ></heim-input>
                    <main class="listInvoices">
                      <form @submit.prevent="addInvoice">
                        <div class="project-invoices">
                          <heim-input class="invoice-url" :label="$t('invoiceNumber')" type="text" name="number"></heim-input>
                          <heim-input class="integrity-key" :label="$t('amountTotal')" type="number" step="0.01" name="amount"></heim-input>
                          <div class="invoice-action-button">
                            <button type="submit" class="paper-action"><heim-icon class="icon" icon="add"></heim-icon><span>{{ $t('add') }}</span></button>
                          </div>
                        </div>
                      </form>
                      <form v-for="(invoice, idx) in project.Invoices" :key="'invoice-'+idx" @submit.prevent="e => updateInvoice(e, invoice.id)">
                        <div class="project-invoices">
                          <heim-input class="invoice-url" :label="$t('invoiceNumber')" type="text" name="number" v-model="invoice.number"></heim-input>
                          <heim-input class="integrity-key" :label="$t('amount')" type="number" step="0.01" name="amount" v-model="invoice.amount"></heim-input>
                          <div class="invoice-action-button">
                            <button type="submit" class="paper-action update"><heim-icon class="icon" icon="edit"></heim-icon><span>{{ $t('edit') }}</span></button>
                          </div>
                          <div class="invoice-action-button">
                            <button type="button" class="paper-action remove" @click="removeInvoice(invoice.id)"><heim-icon class="icon" icon="close"></heim-icon><span>{{ $t('remove') }}</span></button>
                          </div>
                        </div>
                      </form>
                      <p>{{ $t('sold') }} : {{ sales = getSales(project.amount, project.Invoices) }} €</p>
                      <span v-if="checkItems(project.amount, sales)" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ $t('errorSold') }}</span>
                    </main>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('benefits') }}</span>
                <div class="inputs">
                    <heim-select2
                        :label="$t('benefits')"
                        :data="benefits"
                        label-key="name"
                        value-key="id"
                        v-model="project.benefit_id"
                    ></heim-select2>
                    <heim-input
                        :label="$t('numberDay')"
                        name="days"
                        type="number"
                        v-model="project.days"
                        step="0.01"
                    ></heim-input>
                    <heim-input
                        :label="$t('forecastedWorkload')"
                        name="forecasted_workload"
                        type="number"
                        v-model="project.forecasted_workload"
                        step="0.01"
                    ></heim-input>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('comment') }}</span>
                <div class="inputs">
                  <heim-textarea
                      name="comment"
                      type="text"
                      :placeholder="$t('writeComment')"
                      v-model="project.comment"
                  ></heim-textarea>
                </div>
            </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
        <heim-card class="danger-zone">
      <header>
        <h1>{{ $t('dangerZone') }}</h1>
      </header>
      <main>
        <div class="row">
          <div class="lab">
            <p><strong>{{ $t('removingProject') }}</strong></p>
          </div>
          <div class="input">
            <button @click="deleteForm" class="paper-action remove"><heim-icon class="icon" icon="close"></heim-icon><span>{{ $t('remove') }}</span></button>
          </div>
        </div>
        <v-dialog/>
      </main>
    </heim-card>
  </section>
</template>

<script>
import Vue from "vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimSelect2 from "@/components/form/input/select/heim-select2.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

export default {
  name: "ProjectsEdit",
  components: {
    HeimInput,
    HeimTextarea,
    HeimSelect,
    HeimSelect2,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker
  },
  mounted() {
    this.$store.dispatch("getProviders");
    this.$store.dispatch("getUsers");
    const id = this.$route.params.id;
    this.$store.dispatch("getProject", id);
    this.$store.dispatch("getBenefits");
    this.$store.dispatch("getStatus");
    this.$store.dispatch("getTypes");

    this.$watch(
      vm => vm.project,
      val => {
        this.$store.dispatch("setTitle", `Edit project - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      users: state => state.usersState.users,
      benefits: state => state.projectsState.benefits,
      status: state => state.projectsState.status,
      types: state => state.projectsState.types,
      project: state => state.projectsState.project
    })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("updateProject", {
        id: this.project.id,
        project: {
          type_id: this.project.type_id,
          description: this.project.description,
          name: this.project.name,
          title: this.project.title,
          date: this.project.date,
          mantis_id: this.project.mantis_id,
          status_id: this.project.status_id,
          user_id: this.project.user_id,
          quote: this.project.quote,
          amount: this.project.amount,
          benefit_id: this.project.benefit_id,
          amount: this.project.amount,
          days: this.project.days,
          forecasted_workload: this.project.forecasted_workload,
          comment: this.project.comment
        }
      });

      this.$validator.validateAll().then(result => {
        if (result && data) {
          this.$store.dispatch("setToastMessage", {
            message: "updateSuccessful"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/projects/${this.project.id}/details` });
        }
      });
    },
    getSales(total, items) {
      const sales = [];

      if(items) {
        items.map(item => {
          sales.push(Number(item.amount));
        });

        let sold = sales.reduce((a, b) => a + b, 0).toFixed(2);

        return total - sold;
      }
    },
    checkItems(total, sales) {
      if(sales < 0)
        return true;

      let price = total - sales;
      let sold = price < 0 ? true : false;

      return sold;
    },
    async removeProject() {
      const data = await this.$store.dispatch("deleteProject", {
        id: this.project.id
      });
      if (data.success) {
        this.$store.dispatch("setToastMessage", {
          message: "deleteSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
        this.$router.push({ path: `/projects` });
      }
    },
    addInvoice(e) {
      let number =  e.target.number.value;
      let amount = e.target.amount.value;

      if(number != "" && amount != "") {
        const data = this.$store.dispatch("addInvoice", {
          number: number,
          amount: amount,
          project_id: this.project.id
        });

        if (data) {
          this.$store.dispatch("setToastMessage", {
            message: "addInvoiceSuccessful"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
        }

        e.target.number.value = "";
        e.target.amount.value = "";
      }
    },
    updateInvoice(e, id) {
      const data = this.$store.dispatch("updateInvoice", {
        id: id,
        number: e.target.number.value,
        amount: e.target.amount.value,
        project_id: this.project.id
      });

      if (data.id) {
        this.$store.dispatch("setToastMessage", {
          message: "updateInvoiceSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
      }
    },
    removeInvoice(id) {
      const data = this.$store.dispatch("removeInvoice", {
        id: id,
        project_id: this.project.id
      });
      if (data.success) {
        this.$store.dispatch("setToastMessage", {
          message: "updateSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
      }
    },
    deleteForm() {
      this.$modal.show("dialog", {
        title: "Suppression",
        text: "Etes-vous sur de vouloir supprimer ce projet ?",
        buttons: [
          {
            title: "Oui",
            handler: () => {
              this.removeProject();
            }
          },
          {
            title: "Non",
            default: true
          }
        ]
      });
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.vdp-datepicker__calendar .cell.selected,
.vdp-datepicker__calendar .cell:hover {
  background: var(--heim-secondary-color);
  color: #fff;
}
</style>

<style scoped>
.empty-project-admin {
  display: flex;
  flex-direction: column;
  height: 15em;
}
.empty-project-admin .bg {
  background-image: url("/img/undraw_add_user_ipe3.svg");
  background-size: 100% 100%;
  background-position: center;
  height: 100%;
  margin-bottom: 1em;
}
.empty-project-admin .message {
  justify-content: center;
  display: block;
  text-align: center;
}

.paper-card {
  margin-bottom: 1.5em;
}

.project-invoices {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0.8em 0;
}

.listInvoices form {
  border-bottom: 1px solid #eeeeee;
}

.listInvoices form:last-child {
  border-bottom: 0;
}

.project-invoices .heim-input {
  flex: 1;
  padding: 0 10px;
  max-width: calc(32em / 2 + 5px);
}

.project-invoices .heim-input:first-child {
  padding-left: 0;
}

.invoice-url {
  width: 100%;
}

.integrity-key {
  width: 100%;
}

.project-invoices .invoice-action-button {
  display: flex;
  align-items: center;
  margin-right: 1em;
}

.project-invoices .invoice-action-button .update .icon {
  margin: 0 0.5em;
}

.project-invoices .invoice-action-button .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.user-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}

.project-users,
.select-user {
  width: 100%;
}

.select-user .user-list {
  height: 16em;
  overflow-y: auto;
}

.select-user .custom-input {
  position: relative;
  width: 100%;
}

.select-user .custom-input .icon-button {
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 4px;
}

.users {
  width: 100%;
  padding: 0.6rem 1rem;
}

.users .user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 8px;
}
.users .user:hover {
  background-color: var(--heim-grey-color);
}

.users .cell {
  padding: 0.3rem 0.5rem;
}

.users .user .info {
  flex: 1;
}

.users .user .info .email {
  font-size: 0.8rem;
  font-weight: 600;
  word-break: break-word;
}

.users .user .profile {
  display: none;
}

.users .user .avatar {
  font-size: 1.5rem;
  font-weight: 600;
  background-color: var(--heim-secondary-color);
  color: var(--heim-white-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  border: solid thin var(--heim-grey-color);
  cursor: default;
}

.users .remove .paper-action {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.users .user .info .label {
  font-size: 1.2em;
  font-weight: 400;
}

.danger-zone {
  border-top: solid 4px var(--heim-red-color);
}

.danger-zone h1 {
  color: var(--heim-red-color);
}

.danger-zone .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
/* Wide layout: when the viewport width is bigger than 460px, layout
  changes to a wide layout. */
@media (min-width: 460px) {
  .ctn {
    margin: 1em 10em 0 10em;
  }

  .project-users {
    margin-right: 1em;
  }

  .project-users {
    width: 58%;
  }
  .select-user {
    width: 40%;
  }

  .users .user .profile {
    display: block;
  }

  .select-user .custom-input {
    width: 60%;
  }
}

@media screen and (max-width: 1280px) { 
  .project-invoices .heim-input {
    flex: initial;
    padding: 0;
    max-width: 100%;
  }

  .project-invoices .invoice-action-button {
      padding: 5px 0;
  }
}
</style>
